import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Select from 'react-select';
import swal from '@sweetalert/with-react';
// Styles
import { FormStyled, Row, Column } from '../../css/styles/form';
import { SelectStyled } from '../../css/styles/select';
import FilesModalExcel from '../components/FilesModalExcel';

const EmployeeSelectStyled = {
  ...SelectStyled,
  control: base => ({
    ...SelectStyled.control(base),
    padding: 0,
  }),
  valueContainer: provided => ({
    ...SelectStyled.valueContainer(provided),
    padding: '0 15px',
  }),
  input: provided => ({
    ...SelectStyled.input(provided),
    margin: 0,
    padding: 0,
  }),
  placeholder: provided => ({
    ...SelectStyled.placeholder(provided),
    margin: 0,
  }),
  singleValue: provided => ({
    ...provided,
    margin: 0,
  }),
};

const handleValidate = ({ name }) => {
  const errors = {};
  if (!name || !name.trim()) errors.name = 'OBRIGATÓRIO';
  return errors;
};

const handleSubmit = props => async (values, { setSubmitting, resetForm }) => {
  try {
    if (!props.employee) {
      await props.onCreation({ ...values });
    } else {
      await props.onUpdate({ ...values });
    }
    setSubmitting(false);
    resetForm();
  } catch (err) {
    setSubmitting(false);
  }
};

const handleConfirmSubmit = async (e, submitForm, employee) => {
  e.preventDefault(); // evita submit imediato
  // Só pergunta se é edição (ou seja, existe employee)
  if (employee) {
    const confirm = window.confirm('Deseja confirmar a edição deste funcionário?');
    if (!confirm) return; // se cancelar, não faz nada
  }
  // se não houver employee (novo), ou se confirmar, dispara o submit real
  await submitForm();
};

const EmployeeForm = props => {
  const {
    onDelete,
    onNew,
    onEdit,
    employee,
    employees,
    team,
    employeeList,
    employeeForm,
    canDeleteFiles,
    canRegisterEmployees,
  } = props;
  const authPayment =
    team === 'GERENCIA' || team === 'FINANCIA' || team === 'PAGAMENTO' || team === 'RH';

  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: employee ? employee.name : '',
        telephone: employee ? employee.telephone : '',
        cnh: employee ? employee.cnh : '',
        address: employee ? employee.address : '',
        nickname: employee ? employee.nickname : '',
        document: employee ? employee.document : '',
        account: employee ? employee.account : '',
        account_verifying_digit: employee
          ? employee.account_verifying_digit
          : '',
        branch: employee ? employee.branch : '',
        bank: employee ? employee.bank : '',
        key: employee ? employee.key : '',
        deletedAt: employee && employee.deletedAt ? employee.deletedAt.slice(0, 10) : '',
      }}
      validate={handleValidate}
      onSubmit={handleSubmit(props)}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleReset,
        errors,
        touched,
        setFieldValue,
        submitForm,
        isSubmitting,
        dirty,
      }) => {
        const isInactive = !!employee?.deletedAt;
        const employeeStatus = isInactive ? 'DESPEDIDO' : 'ATIVO';
        const employeeStatusColor = isInactive ? '#bf1523' : '#59d99d';

        return (
        <FormStyled>
          <h1 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <span>{employeeForm ? 'FUNCIONÁRIO' : 'NOVO FUNCIONÁRIO'}</span>
            
            {employee && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 'initial', fontWeight: 'normal' }}>
                <strong>Situação:</strong>
                <strong style={{ color: employeeStatusColor }}>
                  {employeeStatus}
                </strong>
              </div>
            )}
          </h1>

          <ul>
            <Row>
              <Column>
                <strong>NOME</strong>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.name && touched.name && <span>{errors.name}</span>}
              </Column>
            </Row>
            <Row>
              <Column>
                <strong>NOME SOCIAL</strong>
                <input
                  id="nickname"
                  name="nickname"
                  type="text"
                  value={values.nickname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.nickname && touched.nickname && (
                  <span>{errors.nickname}</span>
                )}
              </Column>
            </Row>
            <Row>
              <Column>
                <strong>TELEFONE</strong>
                <input
                  id="telephone"
                  name="telephone"
                  type="text"
                  value={values.telephone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.telephone && touched.telephone && (
                  <span>{errors.telephone}</span>
                )}
              </Column>
            </Row>
            <Row>
              <Column>
                <strong>CNH</strong>
                <input
                  id="cnh"
                  name="cnh"
                  type="text"
                  value={values.cnh}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.cnh && touched.cnh && <span>{errors.cnh}</span>}
              </Column>
            </Row>
            <Row>
              <Column>
                <strong>ENDEREÇO</strong>
                <input
                  id="address"
                  name="address"
                  type="text"
                  value={values.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.address && touched.address && (
                  <span>{errors.address}</span>
                )}
              </Column>
            </Row>
            {employee && (
              <Row>
                <Column>
                  <strong>DATA DE DEMISSÃO</strong>
                  <input
                    id="deletedAt"
                    name="deletedAt"
                    type="date"
                    value={values.deletedAt}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Column>
              </Row>
            )}
            {authPayment && (
              <>
                <Row>
                  <Column>
                    <strong>CPF</strong>
                    <input
                      id="document"
                      name="document"
                      type="text"
                      value={values.document}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={14}
                    />

                    {errors.document && touched.document && (
                      <span>{errors.document}</span>
                    )}
                  </Column>
                </Row>
                <Row>
                  <Column>
                    <strong>CONTA</strong>
                    <input
                      id="account"
                      name="account"
                      type="text"
                      value={values.account}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={12}
                    />

                    {errors.account && touched.account && (
                      <span>{errors.account}</span>
                    )}
                  </Column>

                  <Column>
                    <strong>DIGITO VERIFICADOR DA CONTA</strong>
                    <input
                      id="account_verifying_digit"
                      name="account_verifying_digit"
                      type="text"
                      value={values.account_verifying_digit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={1}
                    />

                    {errors.account_verifying_digit &&
                      touched.account_verifying_digit && (
                        <span>{errors.account_verifying_digit}</span>
                      )}
                  </Column>
                </Row>
                <Row>
                  <Column>
                    <strong>AGÊNCIA</strong>
                    <input
                      id="branch"
                      name="branch"
                      type="text"
                      value={values.branch}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={5}
                    />

                    {errors.branch && touched.branch && (
                      <span>{errors.branch}</span>
                    )}
                  </Column>

                  <Column>
                    <strong>BANCO</strong>
                    <input
                      id="bank"
                      name="bank"
                      type="text"
                      value={values.bank}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={3}
                    />

                    {errors.bank && touched.bank && <span>{errors.bank}</span>}
                  </Column>
                </Row>
                <Row>
                  <Column>
                    <strong>CHAVE DE IDENTIFICAÇÃO</strong>
                    <input
                      id="key"
                      name="key"
                      type="text"
                      value={values.key}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={20}
                    />

                    {errors.key && touched.key && <span>{errors.key}</span>}
                  </Column>
                </Row>
              </>
            )}
            <Row>
              <div className="buttons-container">
                {canRegisterEmployees && (
                  <button
                    type="button"
                    disabled={isSubmitting || !values.name || !values.name.trim()}
                    onClick={async e => {
                      e.stopPropagation();

                      if (employee) {
                        const confirmEdit = await swal({
                          title: 'Confirmação',
                          text: 'As informações do funcionário serão atualizadas. \n Deseja continuar?',
                          icon: 'warning',
                          buttons: {
                            cancel: 'Não',
                            confirm: 'Sim',
                          },
                          className: 'swal-small-icon',
                        });

                        if (!confirmEdit) return;
                      }

                      await submitForm();
                    }}
                  >
                    {employee?'SALVAR':'CADASTRAR'}
                  </button>
                )}

                <button
                  type="button"
                  onClick={handleReset}
                  disabled={!dirty || isSubmitting}
                >
                  RESET
                </button>

                {employee && (
                  <>
                    <button type="button" onClick={onNew}>
                      LIMPAR
                    </button>
                    {!employeeList && (
                      <button
                        className="delete"
                        type="button"
                        onClick={onDelete}
                      >
                        EXCLUIR
                      </button>
                    )}
                  </>
                )}

                {employeeForm && employee && (
                  <button type="button" onClick={() => setIsOpen(true)}>
                    ARQUIVOS
                  </button>
                )}
              </div>
            </Row>
          </ul>

          {!employeeList && (
            <>
              <hr />
              <ul>
                <Row>
                  <Column>
                    <strong>FUNCIONÁRIO</strong>
                    <Select
                      styles={EmployeeSelectStyled}
                      id="employee"
                      value={values.employee}
                      placeholder="Selecione um funcionário"
                      onChange={selectedOption => {
                        setFieldValue('employee', selectedOption);
                        onEdit(selectedOption);
                      }}
                      isSearchable
                      options={employees.filter(emp => !emp.deletedAt)}
                      getOptionLabel={item => item.name}
                      getOptionValue={item => item.uuid}
                      name="employee"
                      isLoading={false}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      loadingMessage={() => 'Buscando funcionários'}
                      noOptionsMessage={() => 'Não há funcionários cadastrados'}
                    />
                  </Column>
                </Row>
              </ul>
            </>
          )}
          {employeeForm && employee && (
            <FilesModalExcel
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              onConfirm={() => setIsOpen(false)}
              moduleUuid={employee.uuid}
              canDeleteFiles={canDeleteFiles}
            />
          )}
        </FormStyled>
        );
      }}
    </Formik>
  );
};

EmployeeForm.propTypes = {
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      uuid: PropTypes.string,
    })
  ),
  employee: PropTypes.shape({
    name: PropTypes.string,
    telephone: PropTypes.string,
    cnh: PropTypes.string,
    address: PropTypes.string,
    nickname: PropTypes.string,
    document: PropTypes.string,
    account: PropTypes.string,
    account_verifying_digit: PropTypes.string,
    branch: PropTypes.string,
    bank: PropTypes.string,
    key: PropTypes.string,
  }),
  onDelete: PropTypes.func.isRequired,
  onNew: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

EmployeeForm.defaultProps = {
  employees: [],
  employee: null,
};

export default EmployeeForm;
